export const validateLifeObjectDraft = (draft) => {
  if (!draft.name?.trim()) return 'Give this LifeObject a name before saving.';
  if (
    draft.lifecycle?.recurrence &&
    draft.lifecycle.recurrence !== 'none' &&
    (!draft.lifecycle.startAt || !draft.lifecycle.endAt)
  ) {
    return 'Choose the first start and end for this repeating availability window.';
  }
  if (
    draft.lifecycle?.startAt &&
    draft.lifecycle?.endAt &&
    new Date(draft.lifecycle.endAt) <= new Date(draft.lifecycle.startAt)
  ) {
    return 'The end time must be after the start time.';
  }
  if (
    ['named-users', 'group', 'channel', 'topic', 'connector-segment'].includes(
      draft.audience?.visibility
    ) &&
    (draft.audience?.identifiers || []).length === 0 &&
    !(
      draft.audience?.visibility === 'named-users' &&
      !draft.audience.requireSubscription &&
      draft.audience.recipientKeys?.length
    )
  ) {
    const guidance = {
      'named-users': 'Choose at least one subscriber.',
      group: 'Choose at least one group.',
      channel: 'Choose at least one channel.',
      topic: 'Add at least one topic.',
      'connector-segment': 'Choose at least one connected audience.',
    };
    return guidance[draft.audience.visibility];
  }
  return null;
};
